// 获取 userToken
export const userToken = ({ user }) => user.userToken;
// 获取 userInfo
export const userInfo = ({ user }) => user.userInfo;
// 获取用户状态
export const userStatus = ({ user }) => user.userStatus;
// 获取用户中心信息
export const userMemberCenter = ({ user }) => user.userMemberCenter;
// 获取购买会员订单记录
export const memberOrderList = ({ user }) => user.memberOrderList;
// 获取用户绑卡信息
export const walletBank = ({ user }) => user.walletBank;
// 获取优惠券列表
export const coupons = ({ user }) => user.coupons;
// 获取提币币种列表
export const currencyTypeList = ({ user }) => user.currencyTypeList;
